// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13pPo","delete":"styles_delete__tDesR","update":"styles_update__as8A8","add":"styles_add__EU52w"};